<div class="card-container">
    <!-- Card Header (top tab) -->
    <ng-content select="card-header"></ng-content>
    <div class="card-bg p-3 w-100 rounded-3 my-3 drop-shadow-1 d-flex flex-column h-100">
        <!-- Top Content (optional) -->
        @if (hasTopContent()) {
            <div class="card-top">
                <ng-content select="card-top-content"></ng-content>
            </div>
        }

        <!-- Main Content (scrollable) -->
        <div class="card-main flex-grow-1 overflow-auto">
            <ng-content select="card-main-content"></ng-content>
        </div>

        <!-- Bottom Content (optional) -->
        @if (hasBottomContent()) {
            <div
                class="card-bottom">
                <ng-content select="card-bottom-content"></ng-content>
            </div>
        }
    </div>
</div>

<svg
    style="visibility: hidden; position: absolute"
    width="0"
    height="0">
    <defs>
        <filter
            id="filter0_d_1408_158090"
            x="0"
            y="0"
            width="412"
            height="914"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feFlood
                flood-opacity="0"
                result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite
                in2="hardAlpha"
                operator="out" />
            <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.113725 0 0 0 0 0.32549 0 0 0 0 0.643137 0 0 0 0.33 0" />
            <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1408_158090" />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1408_158090"
                result="shape" />
        </filter>
        <clipPath
            id="bgblur_0_1408_158090_clip_path"
            transform="translate(0 0)">
            <rect
                x="20"
                y="16"
                width="372"
                height="874"
                rx="12" />
        </clipPath>
    </defs>
</svg>
